<div *ngIf="reportType == 'Monthwise'">
  <div class="report-container" id="print-section">
    <!-- Report Header -->
    <div class="report-header">
      <h1 class="company-name">Vivek Saptahik</h1>
      <h2 class="report-title">Advt.Payment Receipt Ledger</h2>
      <div class="report-meta">
        <span class="report-type">Monthwise</span>
        <span class="date-range">
          Date: {{ startDate | date: 'dd-MM-yyyy' }} to {{ endDate | date: 'dd-MM-yyyy' }}
        </span>
      </div>
    </div>

    <!-- Data Table -->
    <table class="data-table">
      <thead>
        <tr class="table-header">
          <th class="month-column">Month & Year</th>
          <th class="amount-column">Received Amount (₹)</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of advtMonthwiseFormBeans; let i = index" 
            class="data-row" 
            [style.animation-delay]="(i * 0.1) + 's'">
          <td class="month-cell">{{ data.month }} {{ data.year }}</td>
          <td class="amount-cell" style="text-align: end;">{{ (data.rcv_amt * 1).toFixed(2) }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="total-row">
          <td class="total-label">Grand Total:</td>
          <td class="total-amount" style="text-align: end;">{{ (advtMonthwiseTotal * 1).toFixed(2) }}</td>
        </tr>
      </tfoot>
    </table>
  </div>

  <!-- Action Buttons -->
  <div class="action-buttons noPrint">
    <button mat-raised-button color="primary" class="export-btn"
            (click)="exportExcel('Contract_InDetails_Report')">
      <mat-icon>download</mat-icon>
      Export to Excel
    </button>
    
    <button mat-raised-button color="primary" class="print-btn"
            printSectionId="print-section" ngxPrint [useExistingCss]="true">
      <mat-icon>print</mat-icon>
      Print Report
    </button>
    <!-- <button style="margin-top: 2%;" mat-raised-button color="primary"
    [useExistingCss]="true"
    (click)="printPageA4Portrait()">
    Print
  </button> -->
    
    <button mat-button mat-dialog-close class="action-btn close-btn">
      <mat-icon>close</mat-icon>
      Close
    </button>
  </div>
</div>